export const SITE = {
  brand: 'AM ESTUDIO',
  tagline: 'Arquitectura · Diseño · Construcción',
  phoneDisplay: '+52 444 417 7181',
  whatsappLink:
    'https://wa.me/524444177181?text=' +
    encodeURIComponent(
      'Hola, vi el sitio de AM Estudio y quisiera cotizar un proyecto arquitectónico.'
    ),
  email: 'contacto@amestudio.mx',
  instagram: 'https://www.instagram.com/am.estudio',
  location: 'San Luis Potosí, México',
};

export const FORM_URL = 'https://readdy.ai/api/form/da8fl84tvq5lvgtnamig';

export const NAV_ITEMS = [
  { label: 'Inicio', to: '/' },
  { label: 'Proyectos', to: '/proyectos' },
  { label: 'Servicios', to: '/#servicios' },
  { label: 'Estudio', to: '/#estudio' },
  { label: 'Cursos', to: '/#cursos' },
  { label: 'Contacto', to: '/#contacto' },
];